// One chip per word (quoted phrases kept whole): `within_keywords` travels as a single
// space-joined string, so this is the only split a URL restore can reproduce.
const TERM_PATTERN = /"[^"]*"|[^\s,]+/g

export const splitKeywordTerms = (text = '') => (text.match(TERM_PATTERN) || []).filter(term => term !== '""')

export const mergeKeywordTerms = (terms, text) => [...new Set([...terms, ...splitKeywordTerms(text)])]

export const getWithinKeywords = state => [...(state.keywordTerms || []), (state.keyword || '').trim()]
  .filter(Boolean)
  .join(' ')
